module.exports = __webpack_public_path__ + "img/aoc-c27g2u-preview.9d8d92d8.png";